import _extends from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/extends";
import React, { useState } from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useRouter } from 'next/router';
import { Logo } from './Logo';
import { UserNav } from './UserNav';
import { Icon } from '../../subkit-ui/basic/Icon';
import { Avatar } from '../../subkit-ui';
import PublishPostDropdownContainer from '../TWPosts/PublishPostDropdownContainer';
import Link from 'next/link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TopBar = function TopBar(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_jsx("div", {
    className: classNames("max-w-full lg:max-w-screen-lg lg:mx-auto flex justify-between items-center px-5 md:px-0"),
    children: props.children
  });
};
export var DashboardTopBar = function DashboardTopBar(_ref2) {
  var props = _extends({}, _ref2);

  return /*#__PURE__*/_jsx(TopBar, {
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Logo, {
        url: props.logoUrl
      }), /*#__PURE__*/_jsx(UserNav, {
        serviceId: props.serviceId,
        serviceSlug: props.serviceSlug,
        providerSlug: props.providerSlug
      })]
    })
  });
};
export var PostEditorTopBar = function PostEditorTopBar(_ref3) {
  var post = _ref3.post,
      provider = _ref3.provider,
      providerService = _ref3.providerService,
      setIsPublished = _ref3.setIsPublished,
      loading = _ref3.loading,
      currentUser = _ref3.currentUser;

  var _useState = useState(false),
      showPublished = _useState[0],
      setShowPublished = _useState[1];

  var publishedDate = post.published ? moment(post.publishedAt).format('MMMM DD, YYYY') : null;
  var publishedTime = post.published ? moment(post.publishedAt).format('h:mm a') : null;
  var publishedText = publishedDate ? "Published on ".concat(publishedDate, " at ").concat(publishedTime) : 'Unpublished';
  var router = useRouter();

  var handleClick = function handleClick() {
    return router.push("/dashboard/".concat(providerService.id, "/posts"));
  };

  var onOpenPublishPostDrodownClick = function onOpenPublishPostDrodownClick(event) {
    event.preventDefault();

    if (currentUser !== null && currentUser !== void 0 && currentUser.limited) {
      toast.error('Please update your payment settings to continue.');
      return;
    }

    if (post.published) {
      if (!loading) setIsPublished(false);
    } else {
      setShowPublished(!showPublished);
    }
  };

  return /*#__PURE__*/_jsx("div", {
    className: "box-shadow-min w-fill bg-white z-10",
    children: /*#__PURE__*/_jsx("div", {
      className: "max-w-full lg:max-w-screen-lg lg:mx-auto",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-between",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex items-center",
          children: [/*#__PURE__*/_jsx(Logo, {
            url: "https://subkit-images.s3.amazonaws.com/images/logo_minimal.svg",
            className: "hidden sm:block mr4"
          }), /*#__PURE__*/_jsxs("div", {
            className: 'hidden sm:flex c-dark-green items-end clickable',
            onClick: handleClick,
            children: [/*#__PURE__*/_jsx(Icon, {
              name: "arrow-left",
              type: "solid"
            }), /*#__PURE__*/_jsx("span", {
              className: "mx-2 font-medium",
              "data-cy": "posts",
              children: "Posts"
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: 'sm:hidden c-dark-green flex items-end clickable pl-3',
            onClick: handleClick,
            children: /*#__PURE__*/_jsx(Icon, {
              name: "chevron-left",
              type: "solid"
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "flex h-22.5 sm:h-auto items-center",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "hidden sm:block pl3 pt2",
              children: [/*#__PURE__*/_jsx("p", {
                className: "mb0 h4 fw-500",
                children: post.title || 'Untitled'
              }), /*#__PURE__*/_jsx("p", {
                className: "mt0 h5 c-gray-5",
                children: publishedText
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "sm:hidden pl3 pt2",
              children: /*#__PURE__*/_jsx("p", {
                className: "mt0 h5 c-gray-5",
                children: publishedText
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex relative pr-8",
          children: [/*#__PURE__*/_jsx(Link, {
            href: "/".concat(provider.slug, "/posts/preview/").concat(post.id),
            children: /*#__PURE__*/_jsx("a", {
              className: "hidden fw-500 text-black sm:block mr-12",
              children: "Preview"
            })
          }), /*#__PURE__*/_jsx("a", {
            href: "#",
            "data-cy": "open-publish-dropdown",
            onClick: onOpenPublishPostDrodownClick,
            className: "fw-500 text-subkit-primary block",
            children: post.published ? 'Unpublish' : 'Publish'
          }), showPublished && /*#__PURE__*/_jsx("div", {
            className: "fixed sm:absolute w-full sm:w-96 h-full sm:h-auto bg-gray-200 sm:bg-white rounded border-transparent right-0 top-0 sm:top-auto sm:p-6 z-20 sm:mt-8 bg-opacity-75 sm:bg-opacity-0",
            children: /*#__PURE__*/_jsx(PublishPostDropdownContainer, {
              post: post,
              loading: loading,
              serviceId: providerService.id,
              isOpen: showPublished,
              setShowPublished: setShowPublished,
              setIsPublished: setIsPublished
            })
          })]
        })]
      })
    })
  });
};
export var PostPreviewTopBar = function PostPreviewTopBar(_ref4) {
  var post = _ref4.post;
  return /*#__PURE__*/_jsx("div", {
    className: "box-shadow-min bg-black text-white fixed w-fill z-10 h-12 flex justify-center items-center",
    children: /*#__PURE__*/_jsxs("p", {
      className: "m-0",
      children: ["This is a preview of your post.", ' ', /*#__PURE__*/_jsx(Link, {
        href: "/dashboard/posts/".concat(post.id),
        children: /*#__PURE__*/_jsx("a", {
          className: "border-solid border-b border-0 inline-block leading-4",
          children: "Edit Post"
        })
      })]
    })
  });
};
export var PostViewTopBar = function PostViewTopBar(_ref5) {
  var props = _extends({}, _ref5);

  var provider = props.provider,
      service = props.service;
  var initials = provider !== null && provider !== void 0 && provider.name ? provider.name[0].toUpperCase() : '';
  return /*#__PURE__*/_jsx("div", {
    className: "box-shadow-min fixed w-fill bg-white z-10",
    children: /*#__PURE__*/_jsx("div", {
      className: "flex justify-center px1",
      children: /*#__PURE__*/_jsx("div", {
        className: "col-12 sm-col-9 md-col-9",
        children: /*#__PURE__*/_jsxs("div", {
          className: classNames('flex items-center justify-between py-0 md:py-2'),
          children: [/*#__PURE__*/_jsx(Avatar, {
            avatar: service === null || service === void 0 ? void 0 : service.avatarUrl,
            initials: initials,
            size: "medium",
            avatarLink: "/".concat(provider === null || provider === void 0 ? void 0 : provider.slug)
          }), /*#__PURE__*/_jsx("div", {
            className: classNames('flex w-fill sm:hidden md:block'),
            children: /*#__PURE__*/_jsx("div", {
              className: "pl2",
              children: /*#__PURE__*/_jsx("h3", {
                children: service === null || service === void 0 ? void 0 : service.name
              })
            })
          })]
        })
      })
    })
  });
};